
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { SearchBar } from "@/components/users/table/SearchBar";
import { Pagination } from "@/components/users/table/Pagination";
import { AdminUser } from "@/types/admin";

interface AdminUserTableProps {
  adminUsers: AdminUser[];
  loading: boolean;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  page: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number) => void;
}

export const AdminUserTable = ({ 
  adminUsers, 
  loading, 
  searchQuery,
  onSearchChange,
  page,
  pageSize,
  totalCount,
  onPageChange
}: AdminUserTableProps) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  return (
    <div className="space-y-4">
      <SearchBar
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
      />

      {loading ? (
        <div className="text-center py-4">Loading admin users...</div>
      ) : adminUsers.length === 0 ? (
        <div className="text-center py-4">
          {searchQuery ? "No matching admin users found" : "No admin users found"}
        </div>
      ) : (
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Email</TableHead>
              <TableHead>Role</TableHead>
              <TableHead>Added Date</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {adminUsers.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{user.email}</TableCell>
                <TableCell>
                  <span className="capitalize">{user.role.replace('_', ' ')}</span>
                </TableCell>
                <TableCell>{new Date(user.created_at).toLocaleDateString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}

      <Pagination
        page={page}
        totalPages={totalPages}
        loading={loading}
        onPageChange={onPageChange}
      />
    </div>
  );
};
